
export default function HeroSection() {
  return (
    <section className="relative min-h-[480px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/146cb7a99853b37bf8b5594d85681693.jpg"
          alt="Aerial view of productive farmland at sunrise"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-950/80 via-emerald-900/50 to-emerald-950/60"></div>
      </div>
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 py-28">
        <div className="max-w-2xl">
          <span className="inline-block text-emerald-400 font-bold text-xs tracking-widest uppercase mb-4">
            ROI Calculator
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-none tracking-wide text-white">
            See What Your<br />Acres Could<br />Be Earning
          </h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-lg leading-relaxed font-light">
            Enter your farm details and find out how much yield and revenue you could recover with precision aerial services.
          </p>
        </div>
      </div>
    </section>
  );
}
